import { Location } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, NgForm } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { FileHandlerService } from 'src/app/services/file-handler.service';
import { HttpService } from 'src/app/services/http.service';
import { LoadingService } from 'src/app/services/loading.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-dccs-add',
    templateUrl: './dccs-add.component.html',
    styleUrls: ['./dccs-add.component.scss']
})
export class DccsAddComponent implements OnInit {

    constructor(
        private http: HttpService,
        private el: ElementRef,
        public fileHandler: FileHandlerService,
        private location: Location,
        public loading: LoadingService,
        private toastr: ToastrService) {
    }
    @ViewChild('theForm') theForm: NgForm | undefined;
    private apiPath = 'dccs';
    stayPage: boolean = false;
    formGroup = new FormGroup({
        type: new FormControl(null),
        bordered: new FormControl(0),
        point: new FormControl(10),
        status: new FormControl(1)
    });
    details: any[] = [{ is_true: 0, image: {} }];
    formChanged = false;
    voice: any = { view: '' };
    question: any = {};
    assetUrl = environment.assetUrl;

    submitForm(form: any): void {
        if (!form.valid) {
            this.el.nativeElement.querySelectorAll('[formcontrolname].ng-invalid')?.[0]?.focus();
            return;
        }
        if (!this.question.file) {
            this.toastr.error('Please upload question image', 'Error');
            return;
        }
        let files = this.details.filter((e: any) => e.image?.file);
        if (!files.length) {
            this.toastr.error('Plese upload answer choice image', 'Error');
            return;
        }
        if (files.length < 2) {
            this.toastr.error('Minimun anwer choice is 2', 'Error');
            return;
        }
        if (!files.filter((e: any) => e.is_true).length) {
            this.toastr.error('Mark 1 correct answer', 'Error');
            return;
        }

        let fdata = new FormData();
        if (form.value.bordered) {
            form.value.bordered = Number(form.value.bordered);
        }
        form.value.details = [];
        files.forEach((e) => {
            fdata.append('images[]', e.image.file);
            form.value.details.push({ is_true: e.is_true });
        })
        fdata.append('voice', this.voice.file);
        fdata.append('question', this.question.file);
        fdata.append('data', JSON.stringify(form.value));
        form.disable();
        this.http.PostFile(this.apiPath + '/create', fdata).then((r: any) => {
            form.enable();
            if (r.success) {
                this.toastr.success('Data saved successfully', 'Success');
                if (this.stayPage) {
                    form?.reset();
                    this.theForm?.resetForm();
                } else {
                    this.back();
                }
            } else {
                if (r.response && r.response.wrong) {
                    Object.keys(r.response.wrong).forEach((key) => {
                        if (key != 'id') {
                            form.get(key)?.setErrors({ serverError: r.response.wrong[key][0] });
                            this.el.nativeElement.querySelectorAll('[formcontrolname="' + key + '"]')?.[0]?.focus();
                        }
                    });
                }
            }
        });
    }

    addDetails(): void {
        this.details.push({ is_true: 0, image: {} });
    }

    removeDetails(i: number): void {
        this.details.splice(i, 1);
        if (!this.details.length) {
            this.addDetails();
        }
    }

    browseImage(i: number): void {
        this.el.nativeElement.querySelectorAll('#input-image-' + i)?.[0]?.click();
    }

    isTrue(ev: any, i: number) {
        if (ev.target?.checked) {
            this.details.forEach((e: any) => e.is_true = 0);
        }
        this.details[i].is_true = Number(ev.target?.checked);
    }

    back(): void {
        this.location.back();
    }

    canDeactivate(): Observable<boolean> | boolean {
        if (this.formChanged && (this.formGroup.valid && !this.theForm?.submitted)) {
            const result = window.confirm('There are unsaved changes! Are you sure?');
            return of(result);
        }
        return true;
    }

    ngOnInit(): void {
        const oldValue = this.formGroup.value;
        this.formGroup.valueChanges.subscribe((e: any) => {
            this.formChanged = (oldValue != e);
        });
    }
}
